import { Shield, X, ArrowRight } from "lucide-react";
import { Button } from "../ui/button";

/**
 * Feb-2026 (User-Wunsch) — Vorschau-Galerie der wassermarkierten Bilder.
 * Wird direkt nach dem Veröffentlichen angezeigt, sobald die Auto-Wasserzeichen-
 * Funktion gelaufen ist. Der Inserent sieht sofort, dass QR-Code + Händlername
 * korrekt sitzen, bevor er zum Dashboard weitergeleitet wird.
 */
const resolveSrc = (src) =>
    src && src.startsWith("http") ? src : `${process.env.REACT_APP_BACKEND_URL || ""}${src || ""}`;

export default function WatermarkPreviewModal({ images = [], onContinue }) {
    return (
        <div
            className="fixed inset-0 z-[100] bg-black/70 flex items-center justify-center p-4"
            data-testid="watermark-preview-modal"
        >
            <div className="bg-white rounded-sm max-w-3xl w-full max-h-[88vh] overflow-auto p-6">
                <div className="flex items-start justify-between mb-3 gap-4">
                    <div>
                        <h3 className="font-display text-xl font-black flex items-center gap-2 text-[#111827]">
                            <Shield className="w-5 h-5 text-[#FFCC00]" /> Bildschutz aktiv
                        </h3>
                        <p className="text-sm text-gray-600 mt-1">
                            Wasserzeichen + QR-Code wurden auf deine Bilder angewendet. Prüfe kurz, ob
                            Händlername und QR-Code korrekt sitzen:
                        </p>
                    </div>
                    <button
                        type="button"
                        onClick={onContinue}
                        className="p-1.5 text-gray-400 hover:text-gray-900 shrink-0"
                        data-testid="watermark-preview-close"
                        aria-label="Schließen"
                    >
                        <X className="w-5 h-5" />
                    </button>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-3 gap-3" data-testid="watermark-preview-grid">
                    {images.map((src, i) => (
                        <div key={`${src}-${i}`} className="relative aspect-square bg-gray-100 rounded-sm overflow-hidden border border-gray-200">
                            <img
                                src={resolveSrc(src)}
                                alt={`Geschütztes Bild ${i + 1}`}
                                className="w-full h-full object-cover"
                                loading="lazy"
                                data-testid={`watermark-preview-img-${i}`}
                            />
                        </div>
                    ))}
                </div>

                <div className="mt-5 flex justify-end">
                    <Button
                        type="button"
                        onClick={onContinue}
                        className="bg-[#111827] hover:bg-black text-white font-bold rounded-sm px-6"
                        data-testid="watermark-preview-continue-btn"
                    >
                        Weiter zum Dashboard <ArrowRight className="w-4 h-4 ml-2" />
                    </Button>
                </div>
            </div>
        </div>
    );
}
